module.exports = __webpack_public_path__ + "img/banner_bag_6eee7b0.png";